import { css } from '@emotion/css';
import { Button, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  margin: 24px;
  justify-content: center;
  align-items: center;
`;

interface FooterButtonsProps {
  onClick: () => void;
  onSkip?: () => void;
  loading: boolean;
  buttonText?: string;
}

export function FooterButtons({
  onClick,
  onSkip,
  loading,
  buttonText,
}: FooterButtonsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={buttonContainer}>
      <Button onClick={onClick} loading={loading}>
        {buttonText ?? t('button.submit')}
      </Button>
      {onSkip !== undefined && (
        <TextButton onClick={onSkip} disabled={loading}>
          {t('button.idontknow')}
        </TextButton>
      )}
    </div>
  );
}
